<template>
<div>
	<button v-if="!isFinalized" class="btn btn-primary mt-2 float-right" v-on:click="addSupplierQuote">
		<i class="fa fa-plus"></i>
		Add
	</button>

	<div>
		<button v-if="selectedRecords.length > 0 && !isFinalized" type="button" class="btn btn-light btn-sm" v-on:click="editBulkSelection">
			<i class="fa fa-pencil-alt"></i>
			Bulk Edit
		</button>
	</div>

	<table-list
		:records="mutatedSupplierQuotes"
		:fields="quotesFields"
		:has-delete="!isFinalized"
		:simple-delete="true"
		:has-edit="!isFinalized"
		:sortable="true"
		:hide-record-count="true"
		record-name="Supplier Quote"
		:records-selectable="!isFinalized"
		id-field="id"
		v-on:selectedRecordsChange="setSelectedRecords"
		v-on:edit="editSupplierQuote"
		v-on:delete="removeSupplierQuote">
	</table-list>

	<info-box class="float-right mb-2" 
		label="Total" 
		:value="totalRecordsValue(mutatedSupplierQuotes).toCurrency()">
	</info-box>
	<div style="clear: both;"></div>

	<modal-dialog :modal-visible="editModal.visible"
		:title="editModal.title"
		confirm-button-text="Save"
		v-on:closeModal="editModal.visible = false"
		v-on:confirm="confirmAddSupplierQuote">

		<field label="Supplier"
			col-class="col-md-4"
			v-model="editModal.payload.supplier_id"
			:params="{
				type: 'select',
				options: optionify($store.suppliers,'name')
			}">
		</field>

		<field label="Description"
			col-class="col-md-4"
			v-model="editModal.payload.description">
		</field>

		<field label="Price"
			col-class="col-md-4"
			v-model="editModal.payload.price"
			:params="{
				type: 'number',
				step: '0.01',
				min: 0
			}">
		</field>

		<field label="Price Adjustment"
			col-class="col-md-4"
			:params="{type:'number',step: 0.0001}"
			v-model="editModal.payload.price_adjustment">
		</field>

		<field label="Markup"
			col-class="col-md-4"
			:params="{type:'number',step: 0.001}"
			v-model="editModal.payload.markup">
		</field>

		<field label="Qty"
			col-class="col-md-4"
			v-model="editModal.payload.qty"
			:params="{
				type: 'number',
				step: '0.001',
				min: 0
			}">
		</field>

		<field label="Total"
			col-class="col-md-4"
			:value="modalTotal.toCurrency()"
			:params="{
				type: 'static'
			}">
		</field>

	</modal-dialog>

	<bid-element-bulk-edit-modal :visible="bulkEditModal.visible"
		title="Bulk Edit"
		:records="selectedRecords"
		type="SupplierQuote"
		:bid-id="component ? component.bid_id : false"
		:component="component"
		v-on:saved="$emit('modelChanged')"
		v-on:closeModal="bulkEditModal.visible = false">
	</bid-element-bulk-edit-modal>
</div>
</template>
<script type="text/javascript">

import InfoBox from "@/components/InfoBox"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import Field from "@/components/Field"

import BidElementBulkEditModal from "@/pages/project/project_tabs/bidding/components/BidElementBulkEditModal"

import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	name: "SupplierQuotesSection",
	components: {
		TableList,
		InfoBox,
		ModalDialog,
		Field,
		BidElementBulkEditModal
	},
	mixins: [ProjectBidMixins],
	props: ["supplierQuotes","component","isFinalized"],
	data() {
		return {
			supplierQuotesLocal: [],
			editModal: {
				visible: false,
				title: "Add Supplier Quote",
				objectRecordId: null,
				payload: {}
			},
			bulkEditModal: {
				visible: false
			},
			selectedRecords: [],
		}
	},
	watch: {
		supplierQuotes() {
			this.supplierQuotesLocal = this.supplierQuotes
		},
		component() {

		}
	},
	computed: {
		modalTotal() {
			return +this.editModal.payload.qty * +this.editModal.payload.price * +this.editModal.payload.price_adjustment * +this.editModal.payload.markup
		},
		mutatedSupplierQuotes() {
			let vm = this
			return this.supplierQuotesLocal.map(quote => {
				let price = +quote.price

				let supplier = vm.$store.suppliers.find(supplier => supplier.id == quote.supplier_id)

				if (supplier)
					quote.supplierName = supplier.name

				if (!("supplierName" in quote))
					quote.supplierName = ""


				let markup = +quote.markup
				quote.markupFormatted = markup.toFixed(3)

				let price_adjustment = +quote.price_adjustment
				quote.priceAdjustmentFormatted = price_adjustment.toFixed(4)

				let qty = +quote.qty
				quote.qtyFormatted = qty.toFixed(3)

				quote.totalRaw = qty * price * price_adjustment * markup

				quote.priceFormatted = price.toCurrency()

				quote.totalFormatted = quote.totalRaw.toCurrency()

				return quote
			})
		},
	},
	methods: {
		addSupplierQuote() {
			this.editModal.visible = true
			this.editModal.title = "Add Supplier Quote"
			this.editModal.payload = {
				price_adjustment: this.getDefaultPriceSetting("SupplierQuote","price_adjustment"),
				markup: this.getDefaultPriceSetting("SupplierQuote","markup")
			}
		},
		confirmAddSupplierQuote() {
			let vm = this

			let payload = {
				bid_component_id: this.component.id,
				type: "SupplierQuote",
				field_values_json: JSON.stringify({
					supplier_id: this.editModal.payload.supplier_id,
					supplierName: this.$store.suppliers.find(supplier => supplier.id == this.editModal.payload.supplier_id).name,
					description: this.editModal.payload.description,
					qty: this.editModal.payload.qty,
					price_adjustment: this.editModal.payload.price_adjustment,
					markup: this.editModal.payload.markup,
					price: this.editModal.payload.price,
					total: this.modalTotal
				}),
				markup: this.editModal.payload.markup,
				price_adjustment: this.editModal.payload.price_adjustment,
				qty: this.editModal.payload.qty,
				rate: this.editModal.payload.price
			}

			if ("objectRecordId" in this.editModal && this.editModal.objectRecordId > 0)
				payload.id = this.editModal.objectRecordId

			this.postData("JobBidComponentObject/save",payload,true).then(response => {
				if (response.success) {
					vm.editModal.visible = false
					vm.$emit("modelChanged")
				}
			})
		},
		removeSupplierQuote(quote,index) {
			let vm = this
			this.postData("JobBidComponentObject/delete",{id: quote.objectRecordId},true).then(response => {
				if (response.success)
					vm.$emit("modelChanged")
			})
		},
		editSupplierQuote(quote,index) {
			this.editModal.visible = true
			this.editModal.title = "Edit Supplier Quote"
			this.editModal.objectRecordId = quote.objectRecordId
			this.editModal.payload = {
				supplier_id: quote.supplier_id,
				description: quote.description,
				qty: quote.qty,
				price: quote.price,
				price_adjustment: quote.price_adjustment,
				markup: quote.markup
			}
		},
		setSelectedRecords(records) {
			this.selectedRecords = records
		},
		editBulkSelection() {
			this.bulkEditModal.visible = true
		},
		fetchSuppliers() {
			let vm = this

			let params = {
				filters: [
					["is_supplier",1]
				]
			}

			this.getJSON("Contact/get",params).then(response => {
				if (response.success)
					vm.$store.suppliers = response.data
			})
		},
	},
	created() {
		this.supplierQuotesLocal = this.supplierQuotes

		if (this.$store.suppliers.length == 0)
			this.fetchSuppliers()
	}
}

</script>